import React, { useEffect, useState } from "react";
import axios from "../../axiosinstens";
import { useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Subevents.css";
import Layouts from "../../Components/Layouts/Layouts";
import { Helmet } from "react-helmet-async";
function Eventlist() {
  const location = useLocation();
  const category_id = location.state?.categorie_id;
  const navigate = useNavigate();

  const [catagory, setCatagorys] = useState([]);
  const [seminar, setSeminar] = useState([]);
  const [activeCategory, setActiveCategory] = useState(category_id);
  const [activeSubcategory, setActiveSubcategory] = useState(null);
  const [key, setKey] = useState(category_id || "all"); // ✅ Default to "all"

  const handleCategoryClick = (id) => {
    setActiveCategory(activeCategory === id ? null : id);
    setActiveSubcategory(null);
    setKey(id);
  };

  const handleSubcategoryClick = (id) => {
    setActiveSubcategory(activeSubcategory === id ? null : id);
    setKey(id);
  };

  const handleSubSubcategoryClick = (id) => {
    setKey(id);
  };

  const getCatagorys = async () => {
    try {
      const response = await axios.get("getAllCategorie");
      setCatagorys(response.data.categories);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getSeminars = async () => {
    try {
      const response = await axios.get("getSeminar");
      const seminarData = response.data.seminar;

      const getPriority = (planName) => {
        if (planName === "Always on Top") return 1;
        if (planName === "Normal") return 2;
        return 3;
      };

      const sortedSeminars = seminarData.sort((a, b) => {
        const priorityA = getPriority(a?.plan_id?.name);
        const priorityB = getPriority(b?.plan_id?.name);
        if (priorityA !== priorityB) return priorityA - priorityB;

        const dateTimeA = new Date(`${a.start_date}`);
        const dateTimeB = new Date(`${b.start_date}`);
        return dateTimeA - dateTimeB;
      });

      setSeminar(sortedSeminars);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    getCatagorys();
    getSeminars();
  }, []);

  const filteredSeminars = seminar.filter((s) => {
    if (key === "all") return true;
    return (
      s.categorie_id === key ||
      s.subcategorie_id === key ||
      s.subsubcategorie_id === key
    );
  });

  return (
    <>
      <Helmet>
        <title>
          Martial Arts Events & Tournaments USA | Spectacular Seminars
        </title>

        <meta
          name="description"
          content="Explore upcoming martial arts seminars, tournaments, workshops, and training events across the USA. Join professional instructors, schools, and martial arts enthusiasts at Spectacular Seminars."
        />

        <meta
          name="keywords"
          content="martial arts events USA, martial arts tournaments, karate events, taekwondo seminars, MMA workshops, jiu jitsu tournaments, martial arts training events, self defense workshops, martial arts classes USA, martial arts championships, combat sports events, martial arts networking, instructor seminars, spectacular seminars events"
        />
      </Helmet>
      <Layouts>
        <div className="evn">
          <h2>
            <span>
              {key === "all"
                ? "All Events"
                : (() => {
                    const category = catagory.find((c) => c._id === key);
                    if (category) return category.name;

                    for (const c of catagory) {
                      const subcategory = c.subcategories?.find(
                        (sc) => sc._id === key,
                      );
                      if (subcategory) return subcategory.name;

                      for (const sc of c.subcategories || []) {
                        const subsubcategory = sc.subsubcategories?.find(
                          (ssc) => ssc._id === key,
                        );
                        if (subsubcategory) return subsubcategory.name;
                      }
                    }

                    return "";
                  })()}
            </span>
          </h2>
          <hr />
        </div>

        <div className="evnsam">
          <div className="container">
            <div className="row">
              <div className="col-md-4">
                <ul className="custom-list">
                  {/* ✅ All Events Filter */}
                  <li
                    className={key === "all" ? "active" : ""}
                    onClick={() => {
                      setKey("all");
                      setActiveCategory(null);
                      setActiveSubcategory(null);
                    }}
                  >
                    All Events
                  </li>

                  {/* Categories and subcategories */}
                  {catagory.map((cat, i) => (
                    <li
                      key={i}
                      className={activeCategory === cat._id ? "active" : ""}
                      onClick={() => handleCategoryClick(cat._id)}
                    >
                      {cat.name}

                      {cat.subcategories && activeCategory === cat._id && (
                        <ul className="sub-list">
                          {cat.subcategories.map((sub, j) => (
                            <li
                              key={j}
                              className={
                                activeSubcategory === sub._id ? "active" : ""
                              }
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSubcategoryClick(sub._id);
                              }}
                            >
                              {sub.name}

                              {sub.subsubcategories &&
                                activeSubcategory === sub._id && (
                                  <ul className="subsub-list">
                                    {sub.subsubcategories.map((s, k) => (
                                      <li
                                        key={k}
                                        className={
                                          key === s._id ? "active" : ""
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          handleSubSubcategoryClick(s._id);
                                        }}
                                      >
                                        {s.name}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="col-md-8">
                <div className="evn-sub-dtls">
                  {filteredSeminars.length === 0 ? (
                    <p
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        border: "2px solid red",
                        borderRadius: "5px",
                      }}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center mt-auto w-100"
                        style={{ minHeight: "400px" }}
                      >
                        <img
                          src="no-events-found.png"
                          alt="No Resources"
                          style={{
                            height: "400px",
                            objectFit: "contain",
                            cursor: "not-allowed",
                          }}
                        />
                      </div>
                      <div className="text-center mt-3">
                        <h2>No Event Found.</h2>
                      </div>
                    </p>
                  ) : (
                    filteredSeminars.map((seminar_data, index) => (
                      <div
                        className="ourevent"
                        onClick={() =>
                          navigate(`/eventdetails/${seminar_data.event_id}`)
                        }
                        key={index}
                      >
                        <div className="ourevent_left">
                          {seminar_data?.plan_id?.name === "Always on Top" && (
                            <div className="ribbon-blank">&nbsp;</div>
                          )}
                          {seminar_data?.plan_id?.name === "Featured Event" && (
                            <div className="ribbon">Featured</div>
                          )}
                          {seminar_data?.plan_id?.name === "Normal" && (
                            <div className="ribbon-blank">&nbsp;</div>
                          )}
                          {seminar_data?.plan_id?.name === "At Will" && (
                            <div className="ribbon-blank">&nbsp;</div>
                          )}
                          <div className="event-details">
                            <div className="container">
                              <div className="row">
                                <div className="col-md-3">
                                  {seminar_data.start_date && (
                                    <div className="evnt_detl">
                                      <h3 style={{ textAlign: "center" }}>
                                        <span>Starts On</span>
                                      </h3>
                                      <h3 style={{ textAlign: "center" }}>
                                        <span
                                          dangerouslySetInnerHTML={{
                                            __html: seminar_data.start_date,
                                          }}
                                        />
                                      </h3>
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-7">
                                  <div className="evnt_det2">
                                    <h4 className="ev">{seminar_data.name}</h4>
                                    {seminar_data.event_type ===
                                      "physical_events" &&
                                      seminar_data.address && (
                                        <p>
                                          {seminar_data.address} ( Physical
                                          Event )
                                        </p>
                                      )}
                                    {seminar_data.event_type ===
                                      "online_event" && <p>( Online Event )</p>}
                                    <p>
                                      {seminar_data.category.name}{" "}
                                      {seminar_data.subcategory &&
                                        " > " +
                                          seminar_data.subcategory.name}{" "}
                                      {seminar_data.subsubcategorie &&
                                        " > " +
                                          seminar_data.subsubcategorie.name}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-md-2">
                                  {seminar_data?.event_price && (
                                    <div className="evnt_detl">
                                      <h4>
                                        From: <br />
                                        {
                                          seminar_data?.settings
                                            ?.currency_symbol
                                        }
                                        {parseFloat(
                                          seminar_data?.event_price,
                                        ).toFixed(2)}
                                      </h4>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layouts>
    </>
  );
}

export default Eventlist;
